import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivityTabs, BookingBehavior, ComponentTypes, chineseLanguageCodes, LocationFilter, LocationViewTypes, ScreenType, SlotType, DEFAULT_LANGUAGE_CODE } from '../constants/commonenums';
import { urlConfig } from '../constants/url-config';
import { FloorPlanImagesDto } from '../dynamicform/models/common-models';
import { OpenBookingDTO, SlotDTO } from '../Models/OpenBookingDTO';
import { AuthorizeIFrameInfoDTO, ContactDTO, CustomGuestFieldsModel, FinancialEffectForUpdatedReservationDTO, RegisterReservationAttemptResponseDTO, ReservationAttemptBasicInfo, ReservationDTO, ReservationInfoDTO, ReservationMultipleAttemptBasicInfo, SecondaryContactDTO } from '../Models/PartyModels';
import { ClassType, LockSessionRequestDTO, SessionBookingDTO } from '../Models/SessionBookingDTO';
import { SlotLockResultDTO } from '../Models/SlotLockModels';
import { DataRetentionPolicy, LanguageFileName, operationType, WidgetSettingsDTO } from '../Models/WidgetSettingsModels';
import { HttpService } from '../services/http.service';
import { Utilities } from '../utilities/utilities';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ComponentDetails } from '../dynamicform/models/popup.interface';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '../components/popup/popup.component';
import moment, { lang } from 'moment';
import _ from 'lodash';
import { GoogleTagManagerService } from 'src/app/core/services/google-tag-manager.service';
import { DEFAULT_LANGUAGE, TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root'
})
export class GuestService {
  public restaurantWidgetName: string;
  public restaurantWidgetId: number;
  public restaurantMerchantCode: any;
  public activityIdFromURL : any;
  public propertyIdFromURL : number;
  public reservationToken: any;
  public operation = operationType.create;
  public language: any;
  public countriesList: any[];
  public LocationList: any[];
  public InstructorList: any[];
  public customGuestFields: any;
  public SessionBookingObj: SessionBookingDTO;
  public openBookingData: OpenBookingDTO;
  public SaveBookingObj: any = {};
  public selectedGuest: any;
  public ispaymentInvolvedInfo: any;
  public reservationAttemptInfo: any;
  languageFileChanges =  new Subject<any>();
  specialMealImage = true;
  public message = {
    message: '',
    state: 0
  };
  public reservationConfirmationText: string;
  public additionalGuestPage: any;
  refundData: any;
  public ConfigSettings: any;
  enableActivities = false;
  enableDining = false;
  slotLockId: number;
  public restaurantImages: BehaviorSubject<FloorPlanImagesDto> = new BehaviorSubject<FloorPlanImagesDto>(null);
  restaurantWidgetSettings$ = new BehaviorSubject<WidgetSettingsDTO>(null);
  allClassActivitiesAvailable$ = new BehaviorSubject<any>(null);
  editPartyData$ = new BehaviorSubject<any>(null);
  bookingPartiesData$ = new BehaviorSubject<any>(null);
  BookNew$ = new BehaviorSubject<any>(null);
  isEditEnable: boolean;
  editFromCart: boolean = false;
  createActivityResponse$ = new BehaviorSubject<any>(null);
  RatePlanList$ = new BehaviorSubject<any>(null);
  SelectedClassSchedule$ = new BehaviorSubject<any>(null);
  TimerOff$: Subject<any> = new Subject<boolean>();
  formValid$: Subject<any> = new Subject<any>();
  TabChange$: Subject<any> = new Subject<any>();
  bookingType$: Subject<any> = new Subject<any>();
  dataRetentionPolicy$ = new BehaviorSubject<DataRetentionPolicy>(null);
  SelectedActivity$ = new BehaviorSubject<any>(null);
  globaactivityServiceeatingAreaId: number;
  isSplitPayment$ = new Subject<boolean>();
  subscriptions: Subscription = new Subscription();
  partySize: number;
  PaymentData$: Subject<any> = new Subject<any>();
  editPartyData: any;
  globalSeatingAreaId: number;
  showTimer = false;
  timerSubscription: Subscription = new Subscription();
  minutes: number;
  seconds: number;
  totalTime: number;
  lockResult: SlotLockResultDTO;
  lockMultipleResult: any;
  lockMultipleIds: any = [];
  bookingSection$ = new BehaviorSubject<any>(null);
  nextButton = new Subject<any>();
  previousButton = new Subject<any>();
  FormChanged = new Subject<any>();
  showMessage: boolean;
  totalSelectedMins = 0;
  additionalGuestRequired: number = 0;
  selectedCountryId: number;
  showPaymentSummary = false;
  primaryContact: ContactDTO;
  secondaryContactList: SecondaryContactDTO[];
  lockCallRequired = false;
  fromclient = false;
  selectedOpenBookingSlots: any = {};
  SlotIds = 0;
  slots_holder: any[];
  MultipledaysSlot_holder: any[];
  allAvailableSlots: any[];
  slotAvailabilitySubject$ = new BehaviorSubject<any>(null);
  partySlots$ = new BehaviorSubject<any>(null);
  cartCount = 0;
  cartListCount = new BehaviorSubject<number>(0);
  CartBookingList$: Subject<any> = new Subject<any>();
  membershipId: number;
  AllocationTypes: any[];
  RefundAmount: number = 0;
  TotalRefundAmount: number = 0;
  availableDates: any[];
  isClassBokking = false;
  byPassValidation = false;
  BookAnotherReservation = new BehaviorSubject<boolean>(false);
  filterAvailabilities = new BehaviorSubject<boolean>(false);
  selectedSpecialMeal: any;
  selectedDiningSpecialMeal: any = {};
  additionalGuestLength: any;
  selectedCartIndex = 0;
  isbookingCompleted = false;
  isSummaryFromCart = false;
  bookedCartList = [];
  hideImage = false;
  imageUrl: any;
  cancelledCartItems$ = new BehaviorSubject<any>(null);
  selectedActivities: any = {};
  selectedDining:any = {};
  selectedRatePlanList: any = {};
  editData: any = {};
  //🐞 Bug Fix | Issue: 48547 | Root: guest detail not retained after navigation back and order summary page went blank after editing reservation | Fix: retained the form data from the editData which holds the guest data  and stored it formData | By: Maris | Date: 07/01/26
  guestData: any = {};
  successBookRes: any = {};
  fromConfirmation = false;
  prevNavURL = '';
  currentNavURL = '';
  loaderRunning = false;
  isDining = false;
  widgetSettings: any = {};
  currentDateTime: Date;
  dateFilterStartDate: Date;
  dateFilterEndDate: Date;
  showGuestFields:boolean = false;
  languageConstants:any;
  public coverTypes: any;
  public bookingTypes: any;
  sessionFilterValue: any = {};
  public loader = new Subject();
  public timer = new Subject();
  public hideBackNavigation = new Subject();
  public backNavigateURL = new Subject();
  public timerCompleted = new Subject();
  public isVersion2 = true;
  public widgetConfigurations = new Subject();
  public merchantImgUrl = new Subject();
  public hideCart = new Subject();
  public selectedLanguage:string;
  public selectedLanguageId: number;
  public languageChange = new Subject(); 
  public cartLoader = false;
  addOnList = [];
  selectedSlot;
  selectedSize: number = 0;
  mealWithConfig: any;
  OperationCurrency : string;
  showLanguageOption = false;
  selectedNonDining: any = {};
  isNonDining: boolean = false;
  selectedNonDiningLocation: any[]= [];
  nonDiningTotalSeatsSelected: number = 0;
  displaySeatingArea: boolean = false;
  displaySeatingType: boolean = false;
  displayLocationType: LocationViewTypes = 0;
  bEnableLocationMultiSelect: boolean = false;
  validateLocationSize: boolean = false;
  chosenStartDate: Date;

  bShowOverbookingErrorDialog: boolean;
  overlapBookingproceedEvent = new BehaviorSubject<any>({});
  allowOverlapBookings: boolean = false;
  isOverlapErrorFromValidateCartApi: boolean = false;
  isSpecialMeal: boolean = false;
  isTableReservation: boolean = false;
  currentComponentName = 0;
  availableLanguages: any = [];
  numberOfFractionalDigits: number = 2;
  DisableCustomTermsAndConditions: boolean = false;
  ContactMinLength: number = 2;
  toListOpenActitivitiesList: boolean = false;
  IsStayGuest: boolean = false;
  IsMember: boolean = false;
  constructor(
    private httpService: HttpService,
    public snackBar: MatSnackBar,
    private router: Router,
    public gtmService:GoogleTagManagerService,
    private dialog: MatDialog, private ts: TranslateService) { }

  clickReserveNow_NonDining(data){
    const filteredStartDate = new Date(this.dateFilterStartDate).setHours(0, 0, 0, 0);
    const userCurrentDate = new Date(new Date(this.currentDateTime).setDate(new Date(this.currentDateTime).getDate() + data?.DaysForReservation - 1)).setHours(0, 0, 0, 0);
    if (data?.DaysForReservation && this.operation === operationType.create && filteredStartDate > userCurrentDate) {
      if (new Date(this.currentDateTime).setHours(0, 0, 0, 0) === userCurrentDate) {
        this.
          openSnackBar(this.ts.instant('bookingsOpenOnlyFor') + moment(this.currentDateTime).format('D MMM, YYYY'), this.ts.instant('close'), this.ConfigSettings.snackBarTime);
      } else {
        this.
          openSnackBar(this.ts.instant('bookingsOpenOnlyFor') + moment(this.currentDateTime).format('D MMM, YYYY') + ' - ' + moment(userCurrentDate).format('D MMM, YYYY'), this.ts.instant('close'), this.ConfigSettings.snackBarTime);
      }
      return;
    }
    this.selectedNonDining = data;
    this.displaySeatingArea = data.WidgetCustomization?.LocationFilters?.filter(x => x == LocationFilter.ByArea).length > 0;
    this.displaySeatingType = data.WidgetCustomization?.LocationFilters?.filter(x => x == LocationFilter.ByType).length > 0;
    this.displayLocationType = data.WidgetCustomization?.LocationViewType || 0;
    this.validateLocationSize = data.AvailabilityOnPartySize || false;

    this.isDining = false;
    this.isNonDining = true;
    this.restaurantWidgetId = data.RestaurantId;

  }

  navigateToUrl(url, queryParams={}, addnlUrl='', skipLocationChange = false, fromCart = false) {
    if(this.showGuestFields && (this.router.url.indexOf("slot-selection") > -1) && !fromCart) {
      this.showGuestFields = false;
    }
    else{
      if (this.operation === operationType.edit && url === 'list') { this.emptyCartData() };
      this.router.navigate([`/v2/activities/${url}/${this.restaurantMerchantCode || ''}${addnlUrl}`], {queryParams,skipLocationChange});
    }    
  }

  navigateToHome(){
    // Security fix: Only allow http/https URLs to prevent XSS via javascript: or data: schemes in HomePageUrl
    const homeUrl = this.widgetSettings?.HomePageUrl?.trim();
    if(homeUrl && /^https?:\/\//i.test(homeUrl)){
      window.location.href = homeUrl;
    }else{
      this.router.navigate([`/v2/activities/list/${sessionStorage.getItem('restaurantMerchantCode') || ''}`]);
    }
  }

  errorImageHandler(event) {
    const image = new Image();
    image.onload = () => {
      event.target.src = image.src;
    };
    image.onerror = () => {
      event.target.src = './assets/images/defaultImage.png';
    };
  }

  getWidgetImagesMerchantLevel(merchantId = '') {
    this.merchantImgUrl.next({
      bannerImg: `${urlConfig.getMerchantLevelImageUrl}?Id=${merchantId ? merchantId : this.widgetSettings.MerchantId}&imageType=0&settingsType=1`,
      logoImg: `${urlConfig.getMerchantLevelImageUrl}?Id=${merchantId ? merchantId : this.widgetSettings.MerchantId}&imageType=2&settingsType=1`,
      backgroundImg: `${urlConfig.getMerchantLevelImageUrl}?Id=${merchantId ? merchantId : this.widgetSettings.MerchantId}&imageType=1&settingsType=1`
    });
  }

  getRestaurantImages(restaurantId) {
    this.httpService.get(urlConfig.getImages + restaurantId).subscribe((images) => {
      const allAvailableImages = images.Payload as FloorPlanImagesDto;
      this.restaurantImages.next(allAvailableImages);
    });
  }

  addGoogleTagManager(tagId: string) {
    this.gtmService['config'] = {
      id : tagId
    };
    if (tagId) {
      this.gtmService.googleTagManagerId = tagId;
      this.gtmService.pushTag({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      })
    }
    else {
      this.gtmService.googleTagManagerId = null;
    }

   // this.gtmService.config.id=this.gtmService.googleTagManagerId;
    sessionStorage.setItem('GTMCode', this.gtmService.googleTagManagerId)
   // this.gtmService.addGtmToDom();
  }

  navigateToPage(){
    if(this.mealWithConfig){
      let mealId= this.mealWithConfig.Id;
      this.hideBackNav();
      this.navigateToUrl(`list` ,null, "/" + mealId, true );
    }
    else{
    this.navigateToUrl(`list`);
    }
  }

  getWidgetSettingsByRestaurantName(restaurantName: string) {
    return this.httpService.get(`${urlConfig.getWidgetSettings}?restaurantName=${restaurantName}&languageId=${this.selectedLanguageId}`).pipe(
      map((data: any) => data.Payload as WidgetSettingsDTO));
  }

  getWidgetSettingsByMerchantCode(merchantCode: string, requireImage = false , languageId:number = 1) {

    const url = `${urlConfig.getWidgetSettingsByMerchantCode}?merchantCode=${merchantCode}&isImageRequired=${requireImage}&languageId=${sessionStorage.getItem('languageId')}`;
    // const url = '../../../assets/config/widgetSettings.json';
    return this.httpService.get(url).pipe(
      map((data: any) => data));
  }

  lockMultiPropertySessions(reqObj) {
    return this.httpService.post(`${urlConfig.lockMultiSessionsURL}`, reqObj);
  }

  unLockMultiPropertySessions(reqObj) {
    return this.httpService.post(`${urlConfig.unLockMultiSessionsURL}`, reqObj);
  }

  lockSessions(restaurantId, reqObj) {
    return this.httpService.post(`${urlConfig.lockSessionsURL}?restaurantId=${restaurantId}`, reqObj);
  }

  getWidgetSettingsByRestaurantId(restaurantId: Number) {
    return this.httpService.get(`${urlConfig.getWidgetSettings}?restaurantId=${restaurantId}`).pipe(
      map((data: any) => data.Payload as WidgetSettingsDTO));
  }

  GetRestaurantPolicy(restaurantId: Number) {
    return this.httpService.get(`${urlConfig.restaurantPolicy}?restaurantId=${restaurantId}`).pipe(map((data: any) => data.Payload as DataRetentionPolicy));
  }

  GetCustomFields(restaurantId: Number) {
    return this.httpService.get(`${urlConfig.getCustomGuestFields}?restaurantId=${restaurantId}`).pipe(map((data: any) => data.Payload as CustomGuestFieldsModel));
  }

  getByToken(token: string, bookingId: string, type?: any) {
    return this.httpService.get(`${urlConfig.getByToken}?token=${token}&bookingId=${bookingId}&type=${type}`).pipe(map((data: any) => data.Payload as ReservationDTO));
  }

  getByCartId(cartBookingId: string, type?: any) {
    return this.httpService.get(`${urlConfig.getByToken}?cartBookingId=${cartBookingId}&type=${type}`).pipe(map((data: any) => data.Payload as ReservationDTO[]));
  }

  getbyBookingId(bookingId: string) {
    return this.httpService.get(`${urlConfig.getByBookingId}?bookingId=${bookingId}`).pipe(map((data: any) => data.Payload as ReservationDTO));
  }

  GetCountries() {
    return this.httpService.get(`${urlConfig.getCountries}`).pipe(map((data: any) => data.Payload));
  }

  GetRestaurantDateAvailability
  (restaurantId: Number, partySize: Number, isCommunalTable: boolean, fromWidget: boolean,
    date, seatingAreaId = null, reservationIdToIgnore = null, specialMealId = null, seatingTypeId = null) {
    return this.httpService.get(`${urlConfig.dateAvailabilityUrl}?restaurantId=${restaurantId}&date=${date}&partySize=${partySize}&isCommunalTable=${isCommunalTable}&fromWidget=${fromWidget}&seatingAreaId=${seatingAreaId}&reservationIdToIgnore=${reservationIdToIgnore}&specialMealId=${specialMealId}&seatingTypeId=${seatingTypeId}`).pipe(map((data: any) => data.Payload));
   }

  GetClassSlots(req): Observable<any> {
    return this.httpService.post(`${urlConfig.GetSlotsForActivityURL}?restaurantId=${req.PropertyId}&options=0`, req);
  }

  GetSessionRatePlanCalculated(request) {
    return this.httpService.post(`${urlConfig.GetRatePlanCalculatedURL}?restaurantId=${this.restaurantWidgetId}&options=0`, request)
  }

  GetPreliminaryReservationInformation(SpecialMealId) {
    return this.httpService.post(`${urlConfig.GetPreliminaryActivityInformationURL}?restaurantId=${this.restaurantWidgetId}&specialMealId=${SpecialMealId}`, '').pipe(map((data: any) => data.Payload as ReservationInfoDTO));

  }
  GetRegisterReservationAttempt(reservationAttemptId: Number) {
    return this.httpService.get(`${urlConfig.getReservationAttemptState}?reservationAttemptId=${reservationAttemptId}`).pipe(map((data: any) => data.Payload as ReservationAttemptBasicInfo));
  }

  RegisterReservationAttemptCart(RegisterReservationAttemptRequest) {
    return this.httpService.post(`${urlConfig.getCartReservationAttempt}?propertyId=${this.restaurantWidgetId}`, RegisterReservationAttemptRequest).pipe(map((data: any) => data.Payload));
  }

  GetRegisterMultipleReservationAttempt(reservationAttemptIds: Number) {
    return this.httpService.post(`${urlConfig.getMultipleReservationAttemptStates}`, reservationAttemptIds).pipe(map((data: any) => data.Payload as ReservationMultipleAttemptBasicInfo[]));
  }

  UpdateReservationAttempt(PaymentCallbackRequest) {
    const updateUrl = PaymentCallbackRequest.ReservationAttemptIds && PaymentCallbackRequest.ReservationAttemptIds.length > 0 ? urlConfig.updateMultipleBookActivityAttempt : urlConfig.updateReservationAttempt;
    return this.httpService.post(updateUrl, PaymentCallbackRequest);
  }


  UpdateMultiCartReservationAttempt(PaymentCallbackRequest) {
    const updateUrl = urlConfig.updateMultipleBookActivityAttempt;
    return this.httpService.post(updateUrl, PaymentCallbackRequest);
  }


  RegisterReservationAttempt(RegisterReservationAttemptRequestDTO, isDining = false) {
    return this.httpService.post((!isDining ? urlConfig.registerBookActivityAttempt : urlConfig.registerReservationAttempt) + '?restaurantId=' + this.restaurantWidgetId, RegisterReservationAttemptRequestDTO).pipe(map((data: any) => data.Payload as RegisterReservationAttemptResponseDTO))
  }
  

  UpdateReservationFinancialEffect(requestBody, isDining = false) {
    return this.httpService.post(urlConfig.getFinancialEffectForUpdatedActivityDTO,requestBody);
  }

  RegisterReservationAttemptMerchantLevel(RegisterReservationAttemptMerchantRequestDTO) { // Merchant level multicart process
    return this.httpService.post(urlConfig.registerMultiReservationAttempt, RegisterReservationAttemptMerchantRequestDTO)
      .pipe(map((data: any) => data.Payload as RegisterReservationAttemptResponseDTO));
  }

  RegisterReservationAttemptMerchantLevelUniversalCart(RegisterReservationAttemptMerchantRequestDTO) { // Merchant level multicart process
    return this.httpService.post(urlConfig.registerMultiReservationAttemptUniversalCart, RegisterReservationAttemptMerchantRequestDTO)
    .pipe(map((data: any) => data.Payload as RegisterReservationAttemptResponseDTO));
  }

  bookCart(cartListReqObj, isOverlapBooking: boolean = false) {
    return this.httpService.post(`${urlConfig.bookCart}?restaurantId=${this.restaurantWidgetId}&ignoreBookingValidation=${false}&allowOverlapBookings=${isOverlapBooking}`, cartListReqObj).pipe(map((data: any) => data.Payload))
  }

  createSessionBooking(request, isOverlapBooking: boolean = false) {
    request.PageMethod = request.Contact.PreferredPageMethod;
    const url = request.BookingBehavior === BookingBehavior.ClassOrSession && urlConfig.createSessionBookingURL ||
      request.BookingBehavior === BookingBehavior.OpenBooking && urlConfig.BookMultipleActivity ||
      request.BookingBehavior === BookingBehavior.PrivateLesson && urlConfig.bookPrivateLesson;
    return this.httpService.post(`${url}?restaurantId=${this.restaurantWidgetId}&allowOverlapBookings=${isOverlapBooking}`,
      request).pipe(map((data: any) => data.Payload))
  }

createMultiSessionBookingrequest(request: any, isOverlapBooking: boolean = false, saveCardToContact: boolean = false) {
  /** 📋 User Story | TFS: 45215 | Description: Transform Sessions to include SessionDTOs for each booking in the request for multi session booking handling **/
  if (Array.isArray(request)) {
    request = request.map(booking => {
      if (booking.Sessions) {
        booking.Sessions = this.addSessionDTOsToPayload(booking.Sessions);
      }
      return booking;
    });
  } else if (request?.Sessions) {
    request.Sessions = this.addSessionDTOsToPayload(request.Sessions);
  }

  return this.httpService.post(
    `${urlConfig.createMultiSessionBookingURL}?ignoreBookingValidation=false&allowOverlapBookings=${isOverlapBooking}&saveCardToContact=${saveCardToContact}`,
    request
  );
}

/** 📋 User Story | TFS: 45215 | Description: Transform Sessions to include SessionDTOs for each booking in the request for multi session booking handling 
 * Adds SessionDTOs array to the Sessions object by splitting SessionIds into individual objects
 * @param sessionsObj - The Sessions object containing Sessions array
 * @returns The Sessions object with SessionDTOs added
 */
addSessionDTOsToPayload(sessionsObj: any): any {
  if (!sessionsObj?.Sessions || !Array.isArray(sessionsObj.Sessions)) {
    return sessionsObj;
  }

  const sessionDTOs = [];

  // Iterate through each session and split SessionIds into individual SessionDTOs
  sessionsObj.Sessions.forEach(session => {
    if (session.SessionIds && Array.isArray(session.SessionIds)) {
      session.SessionIds.forEach(sessionId => {
        sessionDTOs.push({
          Date: session.Date,
          SessionIds: [sessionId],
          SessionId: sessionId,
          LocationGroupId: session.LocationGroupId || null,
          LocationIds: session.LocationIds || null
        });
      });
    }
  });

  return {
    ...sessionsObj,
    SessionDTOs: sessionDTOs
  };
}

  updateSessionBooking(request, isDining = false, isOverlapBooking: boolean = false) {
    request.PageMethod = request.Contact.PreferredPageMethod;
    return this.httpService.post(`${(!isDining ? urlConfig.updateSessionBookingURL : urlConfig.updateReservation)}?restaurantId=${this.restaurantWidgetId}&allowOverlapBookings=${isOverlapBooking}`,
      request).pipe(map((data: any) => data));
  }
  GetFilterValues(req): Observable<any> {
    // return;
    return this.httpService.post(`${urlConfig.getGetFilteredLessonsActivityURL}?restaurantId=${this.restaurantWidgetId}`, req);
  }

  GetFinancialEffectCalculation(reservationDTO, isDining = false) {
    return this.httpService.post((!isDining ? urlConfig.getFinancialEffectForUpdatedActivityDTO : urlConfig.getFinancialEffectForUpdatedReservationDTO) + '?restaurantId=' + this.restaurantWidgetId, reservationDTO).pipe(map((data: any) => data.Payload as FinancialEffectForUpdatedReservationDTO));
  }

  CancelBooking(restaurantId: Number, partyId: Number, language: Number, sessionIds: any = []) {
    return this.httpService.post(`${urlConfig.cancelSessionBooking}?restaurantId=${restaurantId}&partyId=${partyId}&cancelAllOrRemainingSessions=${sessionIds.length ? false : true}&language=${language}`, sessionIds);
  }

  getCancellationCharge(restaurantId: Number, partyId: Number, sessionIds: any = []) {
    return this.httpService.post(`${urlConfig.GetCancellationChargeURL}?restaurantId=${restaurantId}&partyId=${partyId}&cancelAllOrRemainingSessions=${sessionIds.length ? false : true}`, sessionIds);

    // return this.httpService.get(
    //   `${urlConfig.GetCancellationChargeURL}?restaurantId=${restaurantId}&partyId=${partyId}&cancelAllOrRemainingSessions=${cancelAllOrRemainingSessions}&bookedSessionId=${bookedSessionId}`);
  }

  CancelStandByBooking(restaurantId: Number, partyId: Number, language: Number, sessionIds: any = [], bookedSessionId) {
    return this.httpService.post(`${urlConfig.cancelStandByBooking}?restaurantId=${restaurantId}&partyId=${partyId}&cancelAllOrRemainingSessions=${sessionIds.length ? false : true}&language=${language}&bookedSessionId=${bookedSessionId}`, sessionIds);
  }

  // for discontinous slot booking cancellation
  CancelOpenBooking(restaurantId: Number, bookingId: Number, language: Number, partyIds: any = []) {
    return this.httpService.post(`${urlConfig.cancelOpenBookingUrl}?restaurantId=${restaurantId}&bookingId=${partyIds.length ? null : bookingId}&language=${language}`, partyIds);
  }

  // for continous slot booking cancellation
  CancelNonDiningBooking(restaurantId: Number, partyId: Number) {
    return this.httpService.post(`${urlConfig.openBookingCancelUrl}?restaurantId=${restaurantId}&partyId=${partyId}&isFromRejectStandBy=false`, {});
  }

  CancelPrivateLessonBooking(restaurantId: Number, bookingId: Number, language: Number, partyIds: any = []) {
    return this.httpService.post(`${urlConfig.cancelPrivateLessonUrl}?restaurantId=${restaurantId}&bookingId=${partyIds.length ? null : bookingId}&language=${language}`, partyIds);
  }



  GetAuthWaiverForm(restaurantId: Number, formCode: string) {
    return this.httpService.get(urlConfig.getAuthWaiverForm + '?restaurantId=' + restaurantId + '&formCode=' + formCode).pipe(
      map((data: any) => data.Payload as AuthorizeIFrameInfoDTO)
    );
  }

  deleteCartItem(partyId) {
    return this.httpService.post(urlConfig.deleteCartItem + '?restaurantId=' + this.restaurantWidgetId + '&PartyId=' + partyId);
  }

  addToCartItem(request) {
    return this.httpService.post(urlConfig.addToCart + '?restaurantId=' + this.restaurantWidgetId, request);
  }
  validateCart(request) {
    return this.httpService.post(urlConfig.validateCartCustomFields + '?propertyId=' + this.restaurantWidgetId, request);
  }

  validateCartItem(request) {
    return this.httpService.post(urlConfig.validateCartItem + '?propertyId=' + this.restaurantWidgetId, request);
  }
  bookSelectedCartItems(PartyIds: []) {
    return this.httpService.post(urlConfig.bookSelectedCartItems + '?restaurantId=' + this.restaurantWidgetId, PartyIds);
  }

  ReleaseLockSlot(restaurantId: Number, lockId: Number) {
    return this.httpService.post(`${urlConfig.releaseLock}?restaurantId=${restaurantId}&lockId=${lockId}`);
  }
  unlockSessionsUrl(lockId) {
    return this.httpService.post(`${urlConfig.unlockSessionsUrl}?restaurantId=${this.restaurantWidgetId}&lockId=${lockId}`);
  }

  LockCartSessionSlots(lockreq) {
    return this.httpService.post(`${urlConfig.LockCartSessionURL}?restaurantId=${this.restaurantWidgetId}`, lockreq);
  }

  UnlockCart(unlockList) {
    return this.httpService.post(`${urlConfig.UnlockCartSessionURL}?restaurantId=${this.restaurantWidgetId}`, unlockList);

  }

  releaseMultiple(lockId) {
    return this.httpService.post(`${urlConfig.releaseMultipleLocks}?restaurantId=${this.restaurantWidgetId}`, lockId);
  }

  getContactFromEngagebyCardno(cardNo) {
    return this.httpService.get(`${urlConfig.GetContactFromEngagebyCardnoURL}?restaurantId=${this.restaurantWidgetId}&cardNo=${cardNo}`)
  }

  lockTables(slots) {
    return this.httpService.post(`${urlConfig.lockTablesURL}?restaurantId=${this.restaurantWidgetId}`, slots)
  }
  getBackgroundImage(restaurantId: Number) {
    return this.httpService.get(`${urlConfig.backgroundImageUrl}?restaurantId=${restaurantId}`);
  }

  CreateSecondaryContacts(restaurantId: Number, partyId: Number, contactList) {
    return this.httpService.post(urlConfig.createSecondaryContacts + '?restaurantId=' + restaurantId + '&partyId=' + partyId, contactList).pipe(
      map((data: any) => data.Payload as Number)
    );
  }

  setLockIdsResponse(lockResponse, restaurantMerchantCode: string) {
    console.log(lockResponse);
    const slotIdObj: any = [];
    const cartLockObj = this.getSessionData('CartLockList_' + restaurantMerchantCode, true) ? this.getSessionData('CartLockList_' + restaurantMerchantCode, true) : [];
    const cartListObj = this.getSessionData('CartList_' + restaurantMerchantCode, true) ? this.getSessionData('CartList_' + restaurantMerchantCode, true) : [];

    cartLockObj.forEach((eachLock, index) => {
      let slotResultDto = this.findInnerArrayData(lockResponse, eachLock.CartId);
      eachLock.slotLockResp = {
        LockId: slotResultDto && slotResultDto?.SlotLockIdDTO?.Id ? slotResultDto?.SlotLockIdDTO?.Id : 0,
        PropertyId: eachLock.propertyId,
        BookingBehavior: 1
      };
      if (cartListObj[index].isDining) {
        cartListObj[index].TableId = slotResultDto && slotResultDto?.TableLockedDTO?.TableIds ? slotResultDto?.TableLockedDTO?.TableIds : [];
      } else if (cartListObj[index].isNonDining && slotResultDto?.TableLockedDTO?.TableIds) {
        cartListObj[index].TableId = cartListObj[index].TableIds = slotResultDto && slotResultDto?.TableLockedDTO?.TableIds ? slotResultDto?.TableLockedDTO?.TableIds : [];
        eachLock.TableId = eachLock.TableIds = slotResultDto && slotResultDto?.TableLockedDTO?.TableIds ? slotResultDto?.TableLockedDTO?.TableIds : [];
      } 
      

      if(cartListObj[index].Sessions){
      cartListObj[index].Sessions.LockId = eachLock.slotLockResp?.LockId;
      }
      cartListObj[index].Slot = {
        Time: cartListObj[index].isDining ? cartListObj[index].LocalTime : (moment(eachLock.FromDate).format()).split('+')[0],
        LockId: slotResultDto && slotResultDto?.SlotLockIdDTO?.Id ? slotResultDto?.SlotLockIdDTO?.Id : 0,
        Type: cartListObj[index].isDining ? 4 : eachLock.AvailabilityCriteria
      };

      eachLock.isNonDining = cartListObj[index].isNonDining;
      slotIdObj.push(eachLock);
    });
    
    // let filteredItems = lockResponse ? [].concat.apply([], lockResponse).filter(x => Object.keys(x.SlotLockResultDTO || {}).length) : [];
    let filteredItems = lockResponse ? [].concat.apply([], lockResponse).filter(x=> x.SlotLockResultDTO && x.SlotLockResultDTO.SlotLockIdDTO) : [];
    if (filteredItems) {
      slotIdObj.forEach((item, index) => {
        let filteredObjects = filteredItems.filter(listObj => listObj.CartId == item.CartId)
        item.isAvailable = filteredObjects.length > 0 ? true : false;
        if (item.isNonDining) {
          item.Slots = this.setOpenBookingSlotLockIds(item, cartListObj, index, lockResponse);
          cartListObj[index].Slots = item.Slots;
        }
      });
    }
    this.setSessionData('CartLockList_' + restaurantMerchantCode, slotIdObj, true);
    this.setSessionData('CartList_' + restaurantMerchantCode, cartListObj, true);
  }

  findInnerArrayData(lockDetails: any[], Id: string) {
    let lockObject: any = null;
    lockDetails?.forEach(data => {
      lockObject = lockObject === null || lockObject === undefined ? data.find(x => { return x.CartId == Id }) : lockObject;
    });
    return lockObject && lockObject?.SlotLockResultDTO ? lockObject.SlotLockResultDTO : {};
  }

  findRegistrationAttemptArrayData(lockDetails: any[], Id: string ) {
    let lockObject: any = null;
    lockDetails?.forEach(data => {
      if (data.CartId === Id) {
        lockObject = lockObject === null || lockObject === undefined ? data : lockObject;
      }
    });
    return lockObject || {};
  }

  getSlotsForTable(locations, instructors, date, specialMealId?: any): Observable<any> {
    return this.httpService.post(`${urlConfig.GetSlotsForTablesURL}?restaurantId=${this.restaurantWidgetId}&options=1`, {
      ActivityId: specialMealId ? specialMealId : null,
      TableIds: locations,
      InstructorIds: instructors,
      TimeRange: {
        Start: date + "T00:00:00.000",
        End: date + "T23:59:59.999"
      }
    });
  }

  lockMultiPropertySessionsfn(restaurantMerchantCode: string, fromCart = false) {
    const modifiedLockCart = this.formCartLockPayLoad(restaurantMerchantCode);
    this.startLoader();
    this.lockMultiPropertySessions(modifiedLockCart).subscribe(response => {
      this.stopLoader();
      this.lockMultipleResult = response.Payload;  
      this.setLockIdsResponse(response.Payload, restaurantMerchantCode);
      this.operation === operationType.edit ? this.navigateToUrl('order-summary/edit/' + this.restaurantWidgetId) : this.navigateToUrl('order-summary',null,'',false,fromCart);
    });
  }

  runTimer(timerValue) {
    this.totalTime = timerValue;
    this.minutes = Math.floor(this.totalTime / 60);
    this.seconds = Number(this.totalTime % 60);
    this.timerSubscription = interval(1000 * 1).subscribe(() => {
      this.totalTime = this.totalTime - 1;
      this.minutes = Math.floor(this.totalTime / 60);
      this.seconds = Number(this.totalTime % 60);
      if (this.totalTime == 0) {
        this.UnSubscribeTimerAndRedirectToHome();
      }
    })
  }

  generateSlot(dateTime): SlotDTO {
    const slot: SlotDTO = <SlotDTO>{};
    slot.Id = 0;
    slot.IsWebReservable = true;
    slot.LimitedMinPartySize = 0;
    slot.LimitedMaxPartySize = 0;
    slot.ManualSlotType = 0;
    slot.OriginalMaxPartySize = 0;
    slot.OriginalMinPartySize = 0;
    slot.PartyId = null;
    slot.LockExpiresAt = null;
    slot.LockedAt = null;
    slot.SeatingAreaId = null;
    slot.Type = SlotType.Time;
    slot.UpdatedAt = null;
    const slotTime = Utilities.Date(dateTime);
    slot.DateTime = slotTime.format('YYYY-MM-DDTHH:mm:ss');
    return slot;
  }

  allocateTimeUnits(date, currentDate) {
    let timeDifference = date.diff(currentDate, 'milliseconds');
    let secondsToDday = Math.floor((timeDifference) / (1000) % 60);
    let minutesToDday = Math.floor((timeDifference) / (1000 * 60) % 60);
    let hoursToDday = Math.floor((timeDifference) / (1000 * 60 * 60) % 24);
    let daysToDday = Math.floor((timeDifference) / (1000 * 60 * 60 * 24));
    return (daysToDday > 0 ? daysToDday + (daysToDday === 1 ? (' ' + this.ts.instant('dayText') + ' ') : (' ' + this.ts.instant('daysText') + ' ')) : ' ') + 
    (hoursToDday > 0 ? hoursToDday + (hoursToDday === 1 ? (' ' + this.ts.instant('hrText') + ' ') : (' ' + this.ts.instant('hrsText') + ' ')) : ' ') + 
    (minutesToDday ? minutesToDday + (minutesToDday === 1 ? (' ' + this.ts.instant('min') + ' ') : (' ' + this.ts.instant('mins') + ' ')) : 'Currently Running');
  }

  setAdditionalGuest(noofguest?) {
    if (this.operation == operationType.create) {
      this.additionalGuestPage = this.restaurantWidgetSettings$.value.WidgetCustomization.AllowAdditionalGuestDetails;

    }
    this.additionalGuestRequired = noofguest ? noofguest - 1 : this.editPartyData$.value.Size - 1;
  }

  UnSubscribeTimerAndRedirectToHome() {
    this.offTimer();
    this.editPartyData = '';
    //have to check
    this.TabChange$.next(ActivityTabs.BookingSelection);
    // this.navigateToUrl('list');
    //Discard all form Details;
  }

  offTimer() {
    this.TimerOff$.next(false);
    this.showTimer = false;
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  openSnackBar(msg, msgState, duration = 0, panelClass = '') {
    const horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    const verticalPosition: MatSnackBarVerticalPosition = 'bottom';
    const snackConfiguration: any = {
      horizontalPosition,
      verticalPosition
    };

    if (panelClass) {
      snackConfiguration.panelClass = panelClass;
    }
    if (duration > 0) {
      snackConfiguration.duration = duration ? duration : 3000;
    }
    this.snackBar.open(msg, msgState, snackConfiguration);
  }

  setMessageState(msg, msgState) {
    this.message = {
      message: msg,
      state: msgState
    }
  }

  unlockCartURL(unlockCartList) {
    this.UnlockCart(unlockCartList).subscribe(data => {
      console.log(data);
    });
  }
  getCountryId(code) {
    if (code) {
      let countryId = this.countriesList.find(country => country.CountryPhoneCode == code)?.Id;
      return countryId ? countryId : this.countriesList.find(country => country.Name == "USA").Id;
    }
  }

  getCountryIdByName(name){
    if(name){
      let countryId = this.countriesList.find(country => country.Name == name)?.Id;  
       return countryId ? countryId : this.countriesList.find(country => country.Name == "USA").Id;
    }
  }

  loadDefaultImage(event) {
    this.hideImage = true;
  }

  startLoader() {
    this.loaderRunning = true;
    this.loader.next(true);
  }

  stopLoader() {
    this.loaderRunning = false;
    this.loader.next(false);
  }

  startTimer() {
    this.timer.next(true);
  }

  stopTimer() {
    this.timer.next(false);
  }

  hideBackNav() {
    this.hideBackNavigation.next(true);
  }

  showBackNav() {
    this.hideBackNavigation.next(false);
  }

  backNavigation() {
    this.backNavigateURL.next({ URL: this.prevNavURL });
  }

  formCartLockPayLoad(restaurantMerchantCode: string) {
    const modifiedLockCart = [];
    const cartLockObj = this.getSessionData('CartLockList_' + restaurantMerchantCode, true) ? this.getSessionData('CartLockList_' + restaurantMerchantCode, true) : [];
    const cartListObj = this.getSessionData('CartList_' + restaurantMerchantCode, true) ? this.getSessionData('CartList_' + restaurantMerchantCode, true) : [];
    cartLockObj.forEach((eachCart, index) => {
      const { ActivityId, FromDate, Slots, GuestTypes, BookingTypes, Location, StaffId, BookingSize, SessionGroupId } = eachCart;
      const classType = eachCart.ClassType;
      
      // Transform Sessions: split sessions with multiple SessionIds into separate session objects
      let transformedSessions = [];
      if (classType !== ClassType.Class && !cartListObj[index].isNonDining && Slots && Slots.length > 0) {
        Slots.forEach(slot => {
          if (slot.SessionIds && slot.SessionIds.length > 1) {
            // Split sessions with multiple SessionIds into individual sessions
            slot.SessionIds.forEach(sessionId => {
              transformedSessions.push({
                Date: slot.Date,
                SessionIds: [sessionId]
              });
            });
          } else {
            // Keep sessions with single or no SessionIds as is
            transformedSessions.push(slot);
          }
        });
      }
      
      const lockRequest = {
        ActivityId,
        StartDate: (moment(FromDate).format()).split('+')[0],
        BookingSize,
        ClassType: classType,
        lockIdToIgnore: eachCart.slotLockResp?.LockId,
        Sessions: classType === ClassType.Class || cartListObj[index].isNonDining ? [] : transformedSessions,
        Slots: eachCart.LocalTime && !cartListObj[index].isNonDining ? [{
          LocalTime: eachCart.LocalTime
        }] : cartListObj[index].isNonDining ? cartListObj[index].Slots : [],
        SessionGroupId: classType === ClassType.Class ? SessionGroupId : null,
        ReservationIdToIgnore: this.editPartyData$.value?.Id || this.editData?.Id || null,
        PropertyId: eachCart.propertyId,
        PartySize: BookingSize,
        TableIds: eachCart.TableIds || cartListObj[index].TableIds || [],
        SeatingAreaId: eachCart.SeatingArea || eachCart.SeatingAreaId || null,
        SeatingTypeId: eachCart.SeatingType || eachCart.SeatingTypeId || null,
        LocalTime: eachCart.LocalTime,
        CartId: eachCart.CartId,
        AddOns: cartListObj[index].AddOns || Utilities.getSelectedAddOns(this.addOnList)
      } as LockSessionRequestDTO;

      if(!cartListObj[index].UserSelectedTable && cartListObj[index].isNonDining){
        lockRequest.TableIds = [];
      }
      modifiedLockCart.push(lockRequest);
    });
    return modifiedLockCart;
  }


  openCustomPopup(componentDetails: ComponentDetails, fromComponent: ComponentTypes, width?: string, height?: string,
    back?: boolean, title?: string, update?: string, cancel?: string, showAction?: boolean, maxWidth?: string,
    panelClass?: string, selectionView?: boolean, disabled?: boolean) {
    const dialogRef = this.dialog.open(PopupComponent, {
      disableClose: true,
      width,
      height,
      maxWidth,
      panelClass,
      minHeight: 100,
      data: {
        title,
        update,
        cancel,
        componentDetails,
        from: fromComponent,
        back,
        standalone: true,
        showAction,
        selectionView,
        disabled
      }
    });
    return dialogRef;
  }

  getCartCount() {
    this.cartCount = this.getSessionData('CartList_' + this.restaurantMerchantCode, true)?.length ? this.getSessionData('CartList_' + this.restaurantMerchantCode, true).length : 0;
    this.cartListCount.next(this.cartCount);
    return this.cartCount;
  }

  emptyCartData() {
    this.setSessionData('CartList_' + this.restaurantMerchantCode, [], true);
    this.setSessionData('CartLockList_' + this.restaurantMerchantCode, [], true);
    this.triggerCartUpdate();
  }

  triggerCartUpdate() {
    const crypto = window.crypto;
    const array = new Uint32Array(1);
    this.CartBookingList$.next(crypto.getRandomValues(array));
  }

  setSessionData(key: string, data: any, isObject = false) {
    sessionStorage.setItem(key, isObject ? JSON.stringify(data) : data);
  }

  getSessionData(key: string, isObject = false) {
    return isObject ? (sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) : []) : sessionStorage.getItem(key);
  }

  getLanguageIdFromUrl(){
    const url = new URL(window.location.href);
    return url.searchParams.get('language');
  }

  setLanguageIdFromUrl(){
    let language = this.getLanguageIdFromUrl()
    if(language){
      this.language = Number(LanguageFileName[language.toLowerCase().toString()]);
      sessionStorage.setItem('languageId', this.language); 
    }
  }

  setWidgetSettings(setting) {
    let settings = {
      FilterByVenue: setting.FilterByVenue,
      PropertiesEnabled: setting.PropertiesEnabled,
      ActivityViewType: setting.ActivityViewType, // 0, 1, 2
      ViewActivityInfo: setting.ViewActivityInfo,
      IsMembershipFilterEnabled: setting.IsMembershipFilterEnabled,
      AllowLocationSelectionForActivity: setting.AllowLocationSelectionForActivity,
      AllowInstructorSelectionForActivity: setting.AllowInstructorSelectionForActivity,
      HeaderText: setting.HeaderText,
      IsWidgetHeaderEnabled: setting.IsWidgetHeaderEnabled,
      IsWidgetFooterEnabled: setting.IsWidgetFooterEnabled,
      MerchantId: setting.MerchantId,
      MerchantCode: this.restaurantMerchantCode,
      DefaultMobileCountryCode: setting.PropertyWidgetSettings[0].Country || "USA", // Getting the first restaurant detail by default as API provides as array of restaurants
      Languages: setting.Languages,
      IsMultiLanguageSelectionEnabled: setting.IsMultiLanguageSelectionEnabled,
      NumberOfFractionalDigits: setting.NumberOfFractionalDigits,
      DisplayModifyButton: setting.DisplayModifyButton,
      DisplayCancelButton: setting.DisplayCancelButton,
      DisableCustomTermsAndConditions: setting.DisableCustomTermsAndConditions || false,
      // RestaurantDetails: setting.PropertyWidgetSettings
    }
    this.numberOfFractionalDigits = settings.NumberOfFractionalDigits;
    this.widgetConfigurations.next(settings);
    this.setSessionData('rGuestActivitesWidgetSettings_' + this.restaurantMerchantCode, settings, true);
  }

  setOpenBookingSlotLockIds(cartLockObj: any, cartObj:any, index: number, lockResponseArr: any[]){
    const matchedLockResponseObj = lockResponseArr[0]?.find(x => x.CartId == cartLockObj.CartId)?.SlotLockResultDTO?.SlotLockIdDTO;
    return cartObj[index].Slots.map(x => {
      return {
        LocalTime: x.LocalTime,
        Time: x.LocalTime,
        LockId: matchedLockResponseObj?.Id,
        DurationInMinutes: x.DurationInMinutes, 
        Type: 4,
        Duration: x.DurationInMinutes, 
      }
    }); 
  }

  checkLanguageAvailabilityOption(){
    const browserUrl = window.location.pathname;
    const pathList = browserUrl.split("/");
    if(browserUrl.includes('/activities/list/') || browserUrl.includes('/online/')){
      this.showLanguageOption = true
    }
    else{
      this.showLanguageOption = false;
    }
  }


  
  getLanguageConstant(merchantId, restaurantId, screenType?){
  this.GetLanguageConstants(merchantId).subscribe(data =>{
    this.setLanguageConstant(data.Payload,restaurantId,screenType)
  })
}


GetLanguageConstants(merchantId){
  return this.httpService.get(`${urlConfig.getLanguageConstants}?merchantId=${merchantId}&languageId=${this.selectedLanguageId}`);
}

  setLanguageConstant(lngConstants,restaurantId,screenType?){
    this.languageConstants =[];
    if(screenType)
    lngConstants = lngConstants.filter(cnst => cnst.ScreenType == screenType);
  else
  lngConstants = lngConstants.filter(cnst => cnst.RestaurantId == restaurantId && cnst.ScreenType != ScreenType.MerchantSetting);
    lngConstants.forEach(lngConst => {
      this.languageConstants[lngConst.LanguageKey] = JSON.parse(lngConst.LanguageValue);
    })
    
  }

  loadLanguageData(data){
    this.languageFileChanges.subscribe(langChged =>{
      if (langChged && data) {
        var currentURL = new URL(window.location.href);
        if (currentURL.searchParams.has('language')) {
          window.location.href = window.location.origin + window.location.pathname + '?language=' + (langChged ? langChged : data);;
        } else {
          window.location.reload();
          // this.getLanguageConstant(data.MerchantId, data.RestaurantId);
        }
      }
    })

  }

  findLocale(languageId){
    if(this.availableLanguages && this.availableLanguages.length){
    let locale  = this.availableLanguages.find(lang => lang.Id == languageId)?.Code;
    if(chineseLanguageCodes.includes(locale)){
        return 'zh-cn';
    }
    return locale;
  }
  return DEFAULT_LANGUAGE_CODE;
}

resetConfigBasedStyles(){
  this.mealWithConfig = null;
  document.body.classList.remove('spl-meal-config');
  this.hideBackNavigation.next(false);
  this.loadPropertyBannerImage(); 
}

bannerImageHandler(multiRegPayload) {
  if (multiRegPayload?.length && _.uniqBy(multiRegPayload, 'SpecialMealId')?.length == 1) {
    let cart = _.uniqBy(multiRegPayload, 'SpecialMealId')[0];
    let property = this.widgetSettings?.PropertyWidgetSettings?.find(f => f.RestaurantId == cart.PropertyId ||  f.RestaurantId ==  cart.RestaurantId);
    let meal = property?.AvailableSpecialMeals?.find(f => f.Id == cart.SpecialMealId);
    if (meal && !meal.ShowOtherActivities) {
      this.loadSpecialMealImage(meal);
    } else {
      this.loadPropertyBannerImage();
    }
  } else {
    this.loadPropertyBannerImage();
  }
}

loadPropertyBannerImage(){
  if(document.querySelector('.special-meal-banner')){
    document.querySelector('.special-meal-banner').remove();
    let container = document.getElementsByClassName('banner-image');
    container[0].classList.add('d-block');
    container[0].classList.remove('d-none');
  }
}

loadSpecialMealImage(meal){
  document.body.classList.add('spl-meal-config');
  document.body.classList.add('spl-meal_'+ meal.Id);
  if(meal.BannerImageUrl && meal.BannerImageUrl != '' && !document.querySelector('.special-meal-banner')){
  let container = document.getElementsByClassName('banner-image');
  container[0].classList.remove('d-block')
  container[0].classList.add('d-none');
  this.loadBannerImage(meal);
  }
}

loadConfigBasedStyles(meal) {
  this.hideBackNavigation.next(true);
  this.loadSpecialMealImage(meal)

}

loadBannerImage(meal) {
  let img = document.createElement('img');
  img.classList.add('special-meal-banner');
  img.src = meal?.BannerImageUrl;
  if(img.src){
  let container = document.getElementsByClassName('undernav-image');
  container[0].appendChild(img);
  }
}

}
